import { timeBetweenDates } from '../functions/time'

const defaultEntryColor = '#465DEF'
const holidayColor = '#F6E4BB'

/**
 * All available entry types
 * @type {Object}
 */
export const EntryTypes = {
  WORK: 'work',
  // todo the rest (e.g. holiday)
}

/**
 * The minimal time unit available for entries in minutes
 * @type {Number}
 */
export const minTimeUnit = 0
export const defaultTimeUnit = 0

/**
 * Single Entry Abstraction
 */
export default class Entry {
  // eslint-disable-next-line require-jsdoc
  constructor(id, start, end, type, location, comment, teamId, timezone) {
    /** Unique id
     * @type {String} */
    this.id = id
    /** Start date in UTC +0
     * @type {Date} */
    this.start = new Date(start)
    /** End date in UTC +0
     * @type {Date} */
    this.end = new Date(end)
    /** Entry type
     * @type {EntryTypes.WORK} // todo add other types */
    this.type = type
    /** todo what exactly is this */
    this.location = location
    /** Comment
     * @type {String} */
    this.comment = comment
    /** Team id
     * @type {String} */
    this.teamId = teamId

    this.timezone = timezone
    /** Is deleted
     * @type {boolean} */
    this.isDeleted = false
    /**
     * // todo that is this in vue ?
     * @type {boolean}
     */
    this.changed = false
  }

  getTimezone() {
    if (this.location && this.location.timezone) {
      return this.location.timezone
    }

    return this.timezone
  }

  duration() {
    return Math.max(timeBetweenDates(this.start, this.end), 0)
  }

  copy() {
    return new Entry(this.id, this.start, this.end, this.type, this.location, this.comment, this.teamId)
  }

  color() {
    if (this.type == 'work') {
      if (this.location && this.location.color) {
        return this.location.color
      }

      return defaultEntryColor
    } else {
      return holidayColor
    }
  }

  static sortFn(entry1, entry2) {
    if (entry1.teamId < entry2.teamId) {
      return 1
    }
    if (entry1.teamId > entry2.teamId) {
      return -1
    }
    if (entry1.start > entry2.start) {
      return 1
    }
    if (entry1.start < entry2.start) {
      return -1
    }
    return 0
  }
}

export const parseTimezoneEntriesToSections = schedule => {
  if (schedule == null || !Array.isArray(schedule) || !schedule.length) {
    return []
  }

  let usersInPreviousSections = 0
  const sections = []

  for (const userDict of schedule) {
    if (sections.length === 0 || userDict.currentTimezone !== sections[sections.length - 1].timezone) {
      sections.push({
        timezone: userDict.currentTimezone,
        schedule: [],
        usersInPreviousSections: usersInPreviousSections,
      })
    }

    sections[sections.length - 1].schedule.push({
      user: {
        userId: userDict.userId,
        name: userDict.name,
        color: userDict.color,
        avatar: userDict.avatar,
      },
      entries: userDict.entries
        .filter(entry => !entry.isDeleted && !entry.deletedAt)
        .map(entry => new Entry(entry.id, entry.start, entry.end, entry.type, entry.location, entry.comment, entry.teamId, entry.timezone)),
    })

    usersInPreviousSections += 1
  }

  return sections
}
